export default "__VITE_ASSET__Dkgr5_1Q__"